<template>
    <div class="container">
        <br/><h1 class="title">Oups... désolé ... </h1>
        <div class="notification is-danger">
            Vous avez tenté de vous connecter à Petanque.app<br/><br/>
            A priori votre connexion ou votre lien a expiré !<br/><br/>
            N'oubliez pas, votre lien de connexion n'est valable qu'une seule fois !<br/><br/>
            <b>Ouvrez le dernier mail que vous avez reçu pour vous connecter</b> <br/>
            <br/>
            
        </div>
        <s-button theme="is-primary is-large" label="Recommencez" icon="sync" @onclick="home"/>
    </div>
</template>
<script>
export default {
    methods: {
        home() {
            this.$router.push({name: "invite"}).catch(error=>{});
        }
    }
}
</script>